var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndexShape1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 130,
    viewBox: "0 0 126 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.27744 78.2614C-7.19029 109.516 16.4325 136.313 46.8468 127.685L88.9722 115.736C120.827 106.7 136.1 65.9529 116.127 43.2891L88.5024 11.9426C68.5264 -10.7247 28.7433 2.22591 17.7781 34.9655L3.27744 78.2614Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndexShape1);
export default __webpack_public_path__ + "static/media/index-shape-1.e1dfe2bbedc1c666a53a2f4a750f36b7.svg";
export { ForwardRef as ReactComponent };